var moduleMap = {
	"./CorporateResource": () => {
		return Promise.all([__webpack_require__.e(677), __webpack_require__.e(602), __webpack_require__.e(19), __webpack_require__.e(543), __webpack_require__.e(105), __webpack_require__.e(16), __webpack_require__.e(266), __webpack_require__.e(426), __webpack_require__.e(547), __webpack_require__.e(486), __webpack_require__.e(305), __webpack_require__.e(933), __webpack_require__.e(939), __webpack_require__.e(510), __webpack_require__.e(604), __webpack_require__.e(477), __webpack_require__.e(326), __webpack_require__.e(815), __webpack_require__.e(352), __webpack_require__.e(453), __webpack_require__.e(279), __webpack_require__.e(260), __webpack_require__.e(944), __webpack_require__.e(250)]).then(() => (() => ((__webpack_require__(53250)))));
	},
	"./CorporateNavigation": () => {
		return __webpack_require__.e(407).then(() => (() => ((__webpack_require__(12407)))));
	},
	"./corporateCore": () => {
		return Promise.all([__webpack_require__.e(537), __webpack_require__.e(604), __webpack_require__.e(54)]).then(() => (() => ((__webpack_require__(70610)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});